module.exports = __webpack_public_path__ + "c0a83806b48e11eea800172997690cae.MP3";